// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#363636","colorPrimaryText":"#fff","fontBase":"\"Roboto\",sans-serif","colorSecondary":"#8da500","borderRadius":"0"};